import { queryOptions } from '@tanstack/react-query';
import { api, type WorkloadQuery } from '@/api/api';

export const summaryKeys = {
  all: ['summary'] as const,
  workload: (query: WorkloadQuery) => [...summaryKeys.all, 'workload', query] as const,
};

/**
 * The summary report doesn't have its own backend endpoint — it composes from
 * the project timeline (already cached) and workload (period-scoped). Keeping a
 * distinct key namespace lets us cache the workload window the report uses
 * without colliding with the Workload view's keys, which span a different
 * default window.
 */
export const summaryWorkloadOptions = (query: WorkloadQuery) =>
  queryOptions({
    queryKey: summaryKeys.workload(query),
    queryFn: () => api.getWorkload(query),
  });
